<!-- 函数列表 -->
<template>
  <div>
    <el-dialog
      title="添加消息模块"
      :visible.sync="dialogFunctionShow"
      :modal="false"
    >
      <div class="all-function-module">
        <template v-if="checkbox">
          <div class="function-item" v-for="(item, index) in functions">
            <el-checkbox v-model="item.checked" style="width: 100%">
              <div class="name">{{ item.name }}</div>
              <div class="desc"><pre>{{ item.desc }}</pre></div>
            </el-checkbox>
          </div>
        </template>
        <template v-else>
          <div
            class="function-item"
            :class="index == current ? 'select-active' : ''"
            v-for="(item, index) in functions"
            @click="changeFunction(item, index)"
          >
            <div class="name">{{ item.name }}</div>
            <div class="desc"><pre>{{ item.desc }}</pre></div>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFunctionShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Core from "@/libs/src/core";
export default {
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    checkbox: {
      default: false,
      type: Boolean,
    },
    checkedNames: {
      default:()=>{
        return []
      },
      type: Array,
    },
  },
  computed: {
    dialogFunctionShow: {
      set(val) {
        this.$emit("update:show", val);
      },
      get() {
        return this.show;
      },
    },
  },
  watch: {
    show(val) {
      this.dialogFunctionShow = val;
    },
  },
  data() {
    return {
      functions: {},
      current: -1,
    };
  },
  created() {
    this.technology = Core.getProvider("TechnologyTopo");
    // 获取函数列表
    let loadFunction = this.technology.getFunctions();
    let functions = {};
    for (let key in loadFunction) {
      let funcKey = this.technology.jsToken + "__" + key;
      loadFunction[funcKey].checked = false;
      this.checkedNames.forEach((name) => {
        if (loadFunction[funcKey].name == name) {
          loadFunction[funcKey].checked = true;
        }
      });
      functions[key] = loadFunction[funcKey];
    }

    this.functions = functions;
  },
  methods: {
    // 选择的处理函数
    changeFunction(item, index) {
      this.current = index;
      this.selectFunction = item;
    },

    confirm() {
      // 多选
      if (this.checkbox) {
        let checkedFunc = [];
        for (let key in this.functions) {
          if (this.functions[key].checked) {
            checkedFunc.push(this.functions[key]);
          }
        }
        this.$emit("change", checkedFunc); 
        this.dialogFunctionShow = false;
        return;
      }
      if (!this.selectFunction) {
        alert("未选择函数");
        return;
      }
      this.dialogFunctionShow = false;
      this.$emit("change", this.selectFunction);
    },
  },
};
</script>
<style lang="scss" scoped>
.function-list-item {
  display: flex;
  align-items: center;
  padding-right: 10px;
  .function-name {
    width: 120px;
  }
}
.all-function-module {
  height: 350px;
  overflow-y: auto;
  padding: 10px 15px;
  .function-item {
    cursor: pointer;
    padding: 10px 20px;
    &:hover {
      background: rgba($color: #000000, $alpha: 0.2);
    }
    .name {
      font-size: 20px;
      border-bottom: 1px solid #ddd;
    }
    .desc {
      
      color: #888;
      pre{
        user-select: text!important;
      }
    }
  }
  .select-active {
    background: rgba($color: #000000, $alpha: 0.2);
    color: blue;
  }
}
</style>